import { Injectable } from '@angular/core';
import { ApiService } from '@ps-gui/shared-core';
import { Observable } from 'rxjs';
import { ExistingAuftrag } from '../model/existing-alt-auftrag.interface';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ExistingAltAuftraegeRestService extends ApiService {
  protected override get baseUrl(): string {
    return this.backendUrls.psBackendUrl;
  }

  searchExistingAltAuftraege(params: HttpParams): Observable<ExistingAuftrag[]> {
    return super.get(`digidesk/existing-audits`, { params });
  }
}
